<template>
    <div class="main-menu">
        <div class="banner" :style="{'background-image': 'url('+getBanner()+')','min-height':'100px!important'}">
            <nav>
                <div class="container">
                    <div class="row navbar align-items-center">
                        <!--<div class="col-auto">
                            <button class="button secondary back-button" >
                                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="save" width="20.975" height="19.998" class="svg-inline--fa fa-save fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"></path></svg>
                            </button>       
                        </div>-->
                        <div class="col">
                            <div class="logo"></div>
                        </div>
                    </div>
                </div>
            </nav>
            <div class="container">
                <div class="row">
                    <div class="col-sm-10">
                        <div class="user-avatar">
                            <!--<div class="img-avatar" :style="{'background-image': 'url('+getAvatar()+')'}" ></div>-->
                            <div class="img-avatar" @click="changeAvatarImage" > 
                                <img :src="item.imagen" alt="Avatar" class="image" style="width:100%;height:100%">
                                <div class="middle">
                                    <div class="text"><font-awesome-icon icon="pen"/></div>
                                </div>
                                <input
                                    type="file"
                                    style="display: none"
                                    ref="avatarImage"
                                    accept="image/*"
                                    @change="onFilePicked2"
                                >    
                            </div>
                            <!--<div class="img-avatar" v-else>   
                                <img :src="item.imagen" alt="Avatar" class="image" style="width:100%">
                            </div>   -->
                            <div class="data-avatar">
                                <p class="user-name">{{item.nombre}}</p>
                                <!--<p class="user">{{item.nickname}}</p>-->
                                <p class="user">{{item.email}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <button class="edit-lapiz derecha" @click="changeBannerImage"  v-if="nivel=='1'">
                       <font-awesome-icon icon="pen" style="color:#FFF"/>
                    </button>   
                    <input
                        type="file"
                        style="display: none"
                        ref="BannerImage"
                        accept="image/*"
                        @change="onFilePicked"
                    >    
                    </div>
                </div>
           
            </div>
        </div>
    </div>                        
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPen } from '@fortawesome/free-solid-svg-icons'

library.add(faPen)
export default {
    name: 'banner',
    props:['item'],
    data () {
        return{
            nivel:this.$store.state.userInfo.nivel,
            miItem:null,
            banner:'../assets/img/banner.png',
            bannerImage : '',
            BannerFile:'',
            avatar:'',
            avatarImage : '',
            avatarFile:'',
        }
    },
    mounted (){ 
        console.log('banner')
        console.log(this.nivel);
        this.miItem = this.item;
    },
    methods:{
        getAvatar(){
            var imagen = this.item.imagen? this.item.imagen:'';
            return imagen;
        },
        getBanner(){
            var imagen = this.item.banner? this.item.banner:this.banner;
            return imagen;
        },
        changeBannerImage(){
            this.$refs.BannerImage.click ()
        },
        changeAvatarImage(){
            this.$refs.avatarImage.click ()
        },
        onFilePicked (e) {
            const files = e.target.files
            console.log('file picked');
        
			if(files[0] !== undefined) {
                this.bannerImage = files[0].name
                
				if(this.bannerImage.lastIndexOf('.') <= 0) {
					return
				}
				const fr = new FileReader ();
                fr.readAsDataURL(files[0]);

				fr.addEventListener('load', () => {
                    this.banner = fr.result;
                    this.$emit('changeBanner',this.banner);
                    this.BannerFile = files[0]; 

				});
			} else {
				this.bannerImage = ''
				this.BannerFile = ''
				this.banner = ''
			}
        },
        onFilePicked2 (e) {
            const files = e.target.files
            console.log('file picked2');
			if(files[0] !== undefined) {
                this.avatarImage = files[0].name
                
				if(this.avatarImage.lastIndexOf('.') <= 0) {
					return
				}
				const fr = new FileReader ();
                fr.readAsDataURL(files[0]);

				fr.addEventListener('load', () => {
                    this.avatar = fr.result;
                    this.$emit('changeAvatar',this.avatar);
                    this.AvatarFile = files[0]; 

				});
			} else {
				this.avatarImage = ''
				this.avatarFile = ''
				this.avatar = ''
			}
        },
    }
}
</script>
<style scoped>
.main-menu {
z-index:1!important;
}
.user-avatar{
padding: 0!important;
cursor: pointer;

}

.user-avatar .img-avatar {
  position: relative;
}

.image {
  opacity: 1;
  display: block;
  width: 100%;
  height: auto;
  transition: .5s ease;
  backface-visibility: hidden;
  border-radius: 100%;
   
}

.middle {
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.user-avatar :hover .image {
  opacity: 0.3;
}

.user-avatar :hover .middle {
  opacity: 1;
}

.text{
    width:100%;
    padding:10px;
    /*border-radius: 100%;
    border: 2px solid white;*/
    color: white;
    font-size: 16px;
}
</style>

